export enum RoleUser{
    SUPER_ADMIN = 'SUPER_ADMIN',
    ADMIN = 'ADMIN',
    SUPPORT = 'SUPPORT',
    PARENT = 'PARENT',
    TEACHER = 'TEACHER',
   // ENFANT = 'ENFANT',
}